import React from 'react';
import { Skeleton} from 'antd';
import './Sidebar.css';

export const Sidebar = (props) => {
    if(!props.children) {
        return <Skeleton active />;
    }

    return (
        <div className={`sidebar ${props.visible ? "open" : ""}`} style={{ width: props.visible && (props.width || '600px') || 0}}>
            <div className="content">
                <button className="closebtn" onClick={props.onClose}>✕</button>
                <h2>{props.title}</h2>
                <div className="sidebar-content">
                    {props.children}
                </div>
                
               
            </div>
        </div>
    )
}